export const brandStory = {
  // Hero Section
  hero: {
    label: 'MARKA HİKAYEMİZ',
    title: 'Mirasın,\nHassasiyetin ve\nVizyonun Buluştuğu Yer',
    intro: 'LUCENDO, tek bir inançla yaratıldı: gerçek kalite, mirasın, hassasiyetin ve vizyonun buluştuğu yerde doğar.',
    paragraph1: 'MIACCENDO (MİACCENDO GIDA SANAYİ VE TİCARET LİMİTED ŞİRKETİ) bünyesinde yer alan Lucendo, premium yiyecek ve içecek çözümlerinde küresel uzmanlığın rafine bir ifadesi olarak öne çıkar. MIACCENDO\'nun stratejik gücü, sektörel bilgisi ve mükemmeliyete olan bağlılığıyla desteklenen Lucendo, üretimin en seçkin geleneklerini modern inovasyonla bir araya getirir.',
    paragraph2: 'Bizi tek bir köken tanımlamaz — bizi yükselten, çokluktur.',
  },

  // Heritage Cards
  heritage: {
    italy: {
      title: 'İTALYA\'DA KÖK SALMIŞ',
      paragraph1: 'LUCENDO\'nun kalbinde, kahve kültürünün dünyadaki en saygın yuvası olan İtalya\'da gururla üretilen İtalyan kahvemiz yer alır.',
      paragraph2: 'Deneyimli kavurucular tarafından hazırlanan ve nesiller boyu aktarılan uzmanlıkla yönlendirilen kahvemiz, İtalya\'nın zamansız ustalığını yansıtır: zengin aroma, dengeli gövde ve ayırt edilemez karakter. Her harman, İtalyan kahve zanaatkârlığını tanımlayan özgünlük, hassasiyet ve mükemmeliyet ritüeline bir saygı duruşudur.',
    },
    turkey: {
      title: 'TÜRKİYE\'DE MÜHENDİSLİĞİ YAPILMIŞ',
      paragraph: 'LUCENDO\'nun genişletilmiş ürün portföyü, ileri gıda üretim yetkinlikleri ve inovasyona olan bağlılığıyla tanınan Türkiye\'de üretilmektedir. Milkshake\'lerimiz, glaze\'lerimiz, soslarımız ve HoReCa çözümlerimiz; premium lezzet, tutarlılık ve performans sağlamak üzere sıkı kalite standartları altında üretilir. Profesyonel ortamlar için geliştirilen bu ürünler; güvenilir sonuçlar, rafine lezzet profilleri ve özel marka ile özelleştirilmiş uygulamalar için esnek seçenekler sunar. Türkiye\'nin üretimdeki mükemmeliyeti, HoReCa profesyonellerinin dünya genelinde değişen ihtiyaçlarını karşılarken verimlilik ile tavizsiz kalite arasında denge kurmamızı sağlar.',
    },
  },

  // Closing Statement
  closing: {
    quote: 'İki ülke. Tek vizyon. Tavizsiz mükemmeliyet.',
  },
};